module.exports = __webpack_public_path__ + "img/Skirt-Front-B9-Da-Fc-Hc-Ib-Ja.d2928c7c.png";